import ProhibitedItems from "./prohibited-items";

export default ProhibitedItems